/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { Select } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { getProductGroupNamesService } from "api/services/product.api";
import { GroupNames } from "interfaces/ApiInterface/IProductGroupList";
import { getUserData } from "utils";

interface GroupNameFilterProps {
  getProductList: (groupName: string) => void;
  setSelectedGroupName: (groupName: string) => void;
  refreshFilterList: boolean;
  selectedGroupName: string;
}

const GroupNameFilter: React.FC<GroupNameFilterProps> = ({
  getProductList,
  setSelectedGroupName,
  refreshFilterList,
  selectedGroupName,
}: GroupNameFilterProps) => {
  const [groupNames, setGroupNames] = useState<GroupNames[]>([]);

  const onChange = (value: string) => {
    ReactGA.event({
      category: "group_name_filter",
      action: "Group name dropdown value clicked",
      label: "Group name dropdown value clicked"
    });
    getProductList(value);
    setSelectedGroupName(value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const GetGroupList = async (): Promise<void> => {
    const userData = getUserData();
    getProductGroupNamesService(userData?.UserId)
      .then((res) => {
        if (res && res?.data.length > 0) {
          const selectItem: GroupNames = {
            value: "",
            label: "Select All",
          };
          const groupNameObjectArray: GroupNames[] = res?.data
            .filter((groupItem: string) => groupItem && groupItem !== "")
            .map((groupName: string) => ({
              value: groupName,
              label: groupName,
            })) as GroupNames[];
          setGroupNames([selectItem, ...groupNameObjectArray] as GroupNames[]);
        }
      })
      .catch((error: Error) => {
        throw error;
      });
  };

  useEffect(() => {
    GetGroupList();
  }, [refreshFilterList]);

  return (
    <Select
      showSearch
      optionFilterProp="children"
      className="group-name-filter"
      onChange={onChange}
      filterOption={filterOption}
      suffixIcon={<CaretDownOutlined style={{ pointerEvents: "none" }} />}
      value={selectedGroupName}
      options={groupNames}
    />
  );
};

export default GroupNameFilter;
